import React from 'react';
import { prop } from 'ramda';
import { NavLink } from 'react-router-dom';

import Button, { buttonType, buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

import { ACTION } from '../../../../constants';

export default class ChangeStatus extends React.Component {
  render() {
    const { availableActions, applicationId, changeStatus, user } = this.props;

    const link = `/${user.getManufacturerCode()}/component/application/${applicationId}/edit`;

    const actions = [
      {
        key: 'edit',
        isShown: true,
        Component: () => (
          <NavLink to={link}>
            <EditApplicationButton className='_height_40 _width_pc_100 _max_width_180 _margin_right_20' />
          </NavLink>
        ),
      },
      {
        key: 'approve',
        isShown: availableActions.includes(ACTION.APPROVE),
        Component: () => (
          <Button
            label='Approve'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={changeStatus(ACTION.APPROVE)}
            color={buttonColor.green}
          />
        ),
      },
      {
        key: 'deactivate',
        isShown: availableActions.includes(ACTION.DEACTIVATE),
        Component: () => (
          <Button
            label='Deactivate'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={changeStatus(ACTION.DEACTIVATE)}
            color={buttonColor.red}
          />
        ),
      },
      {
        key: 'incomplete',
        isShown: availableActions.includes(ACTION.INCOMPLETE),
        Component: () => (
          <Button
            label='Incomplete'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={changeStatus(ACTION.INCOMPLETE)}
            type={buttonType.primary}
            color={buttonColor.lightBlue}
          />
        ),
      },
      {
        key: 'reactivate',
        isShown: availableActions.includes(ACTION.REACTIVATE),
        Component: () => (
          <Button
            label='Reactivate'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={changeStatus(ACTION.REACTIVATE)}
            type={buttonType.primary}
            color={buttonColor.green}
          />
        ),
      },
      {
        key: 'submit',
        isShown: availableActions.includes(ACTION.RESUBMIT),
        Component: () => (
          <Button
            label='Submit'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={changeStatus(ACTION.RESUBMIT)}
            type={buttonType.primary}
            color={buttonColor.green}
          />
        ),
      },
    ];

    if (actions.filter(prop('isShown')).length === 0) {
      return null;
    }

    return (
      <section className='scene_section detailsScene__change-status-section'>
        <header>Actions</header>
        <div className='detailsScene__change-status-buttons-wrapper'>
          {actions.map(({ key, isShown, Component }) => isShown && <Component key={key} />)}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/ChangeStatus.jsx